{
  "metadata": {
    "id": "orng-light",
    "name": "Orng",
    "description": "Портировано из темы «Orng» (light)",
    "author": "OpenCode",
    "version": "2.0.0",
    "variant": "light",
    "tags": [
      "light",
      "ported"
    ],
    "source": {
      "file": "orng.json",
      "project": "opencode",
      "url": "https://github.com/anomalyco/opencode",
      "upstreamFile": "packages/ui/src/theme/themes/orng.json",
      "license": "MIT",
      "authoring": null
    },
    "validation": {
      "checks": 34,
      "fails": [],
      "paletteMinDeltaE": 31.0,
      "paletteTarget": 20.0,
      "paletteFloor": 18.0,
      "paletteAvgS": 0.441,
      "paletteMaxS": 0.514,
      "paletteAcid": 0,
      "surfacesMinDeltaE": 8.0,
      "surfacesTarget": 8.0,
      "surfacesRaisedTarget": 10.0,
      "surfacesAway": false,
      "syntaxMinDeltaE": 19.9,
      "syntaxVsTextMinDeltaE": 29.0,
      "chartsMinDeltaE": 23.7,
      "textSeparationDeltaE": 22.2,
      "textSeparationTarget": 10.0,
      "textSeparationFloor": 8.0,
      "textSeparationTinted": false,
      "authorialCollisions": [
        {
          "a": "keyword",
          "b": "number",
          "deltaE": 0.0
        },
        {
          "a": "function",
          "b": "operator",
          "deltaE": 0.0
        }
      ],
      "modeLabel": "light",
      "modeFromLuminance": "light",
      "paletteIdenticalToPeer": false
    }
  },
  "colors": {
    "primary": {
      "base": "#EC5B2B",
      "hover": "#d45227",
      "active": "#c24b23",
      "foreground": "#000000",
      "muted": "#ec5b2b80",
      "emphasis": "#EC5B2B"
    },
    "surface": {
      "background": "#ffffff",
      "foreground": "#1a1a1a",
      "muted": "#d1d1d1",
      "mutedForeground": "#4a4a4a",
      "elevated": "#bababa",
      "elevatedForeground": "#1a1a1a",
      "raised": "#9f9f9f",
      "raisedForeground": "#1a1a1a",
      "overlay": "#ffffff33",
      "subtle": "#e8e8e8"
    },
    "interactive": {
      "border": "#979797",
      "borderHover": "#bfbfbf",
      "borderFocus": "#EC5B2B",
      "selection": "#1a1a1a24",
      "selectionForeground": "#1a1a1a",
      "focus": "#ec5b2b59",
      "focusRing": "#ec5b2b47",
      "cursor": "#1a1a1a",
      "hover": "#1a1a1a17",
      "active": "#1a1a1a24"
    },
    "status": {
      "error": "#d1383d",
      "errorForeground": "#ffffff",
      "errorBackground": "#d1383d1a",
      "errorBorder": "#d1383d59",
      "warning": "#d14213",
      "warningForeground": "#ffffff",
      "warningBackground": "#d142131a",
      "warningBorder": "#d1421359",
      "success": "#0062d1",
      "successForeground": "#ffffff",
      "successBackground": "#0062d11a",
      "successBorder": "#0062d159",
      "info": "#2e808d",
      "infoForeground": "#ffffff",
      "infoBackground": "#2e808d1a",
      "infoBorder": "#2e808d59"
    },
    "pr": {
      "open": "#0062d1",
      "draft": "#5a5a5a",
      "blocked": "#d14213",
      "merged": "#c94d24",
      "closed": "#d1383d"
    },
    "syntax": {
      "base": {
        "background": "#d1d1d1",
        "foreground": "#1a1a1a",
        "comment": "#5a5a5a",
        "keyword": "#a2330f",
        "string": "#0056b8",
        "number": "#a2330f",
        "function": "#23616b",
        "variable": "#aa272b",
        "type": "#6f5414",
        "operator": "#23616b"
      },
      "tokens": {
        "commentDoc": "#5a5a5a",
        "stringEscape": "#23616b",
        "keywordImport": "#a2330f",
        "storageModifier": "#a2330f",
        "functionCall": "#23616b",
        "method": "#23616b",
        "variableProperty": "#23616b",
        "variableOther": "#aa272b",
        "variableGlobal": "#a2330f",
        "variableLocal": "#23616b",
        "parameter": "#aa272b",
        "constant": "#a2330f",
        "class": "#6f5414",
        "className": "#6f5414",
        "interface": "#6f5414",
        "struct": "#6f5414",
        "enum": "#6f5414",
        "typeParameter": "#6f5414",
        "namespace": "#6f5414",
        "module": "#a2330f",
        "tag": "#a2330f",
        "jsxTag": "#a2330f",
        "tagAttribute": "#23616b",
        "tagAttributeValue": "#0056b8",
        "boolean": "#a2330f",
        "decorator": "#a2330f",
        "label": "#23616b",
        "regexp": "#0056b8"
      }
    },
    "charts": {
      "series": [
        "#EC5B2B",
        "#2e808d",
        "#0062d1",
        "#d18113",
        "#d1383d"
      ]
    },
    "chat": {
      "background": "#ffffff",
      "userMessage": "#1a1a1a",
      "userMessageBackground": "#bababa",
      "assistantMessage": "#1a1a1a",
      "assistantMessageBackground": "#d1d1d1",
      "timestamp": "#5a5a5a",
      "divider": "#979797",
      "typing": "#5a5a5a"
    },
    "loading": {
      "spinner": "#EC5B2B",
      "spinnerTrack": "#d1d1d1",
      "skeleton": "#d1d1d1",
      "shimmer": "#c6c6c6"
    },
    "tools": {
      "background": "#d1d1d1",
      "border": "#979797",
      "headerHover": "#c8c8c8",
      "icon": "#d14213",
      "title": "#1a1a1a",
      "description": "#5a5a5a",
      "edit": {
        "added": "#0062d1",
        "addedBackground": "#0062d11a",
        "removed": "#d1383d",
        "removedBackground": "#d1383d1a",
        "modified": "#2e808d",
        "modifiedBackground": "#2e808d1a",
        "lineNumber": "#5a5a5a"
      }
    },
    "markdown": {
      "heading1": "#1a1a1a",
      "heading2": "#1a1a1a",
      "heading3": "#1a1a1a",
      "heading4": "#1a1a1a",
      "link": "#d14213",
      "linkHover": "#c74d25",
      "inlineCode": "#0056b8",
      "inlineCodeBackground": "#d1d1d1",
      "blockquote": "#5a5a5a",
      "blockquoteBorder": "#979797",
      "listMarker": "#ec5726",
      "bold": "#1a1a1a",
      "italic": "#1a1a1ae6",
      "strikethrough": "#5a5a5a",
      "hr": "#979797"
    }
  },
  "palette": {
    "version": 1,
    "colors": [
      {
        "key": "a1",
        "name": "Красный",
        "hex": "#8a393f",
        "foreground": "#ffffff",
        "contrast": 7.67
      },
      {
        "key": "a2",
        "name": "Лососевый",
        "hex": "#bc7545",
        "foreground": "#000000",
        "contrast": 5.77
      },
      {
        "key": "a3",
        "name": "Янтарный",
        "hex": "#d5c196",
        "foreground": "#000000",
        "contrast": 11.9
      },
      {
        "key": "a4",
        "name": "Салатовый",
        "hex": "#c1c354",
        "foreground": "#000000",
        "contrast": 11.2
      },
      {
        "key": "a5",
        "name": "Лаймовый",
        "hex": "#658f41",
        "foreground": "#000000",
        "contrast": 5.56
      },
      {
        "key": "a6",
        "name": "Светло-зелёный",
        "hex": "#51c04f",
        "foreground": "#000000",
        "contrast": 9.0
      },
      {
        "key": "a7",
        "name": "Зелёный",
        "hex": "#92dca5",
        "foreground": "#000000",
        "contrast": 13.0
      },
      {
        "key": "a8",
        "name": "Мятный",
        "hex": "#438e7b",
        "foreground": "#000000",
        "contrast": 5.39
      },
      {
        "key": "a9",
        "name": "Бирюзовый",
        "hex": "#92d3db",
        "foreground": "#000000",
        "contrast": 12.56
      },
      {
        "key": "a10",
        "name": "Голубой",
        "hex": "#387593",
        "foreground": "#ffffff",
        "contrast": 5.08
      },
      {
        "key": "a11",
        "name": "Синий",
        "hex": "#354887",
        "foreground": "#ffffff",
        "contrast": 8.65
      },
      {
        "key": "a12",
        "name": "Васильковый",
        "hex": "#3f3eb3",
        "foreground": "#ffffff",
        "contrast": 8.23
      },
      {
        "key": "a13",
        "name": "Фиолетовый",
        "hex": "#a990d0",
        "foreground": "#000000",
        "contrast": 7.59
      },
      {
        "key": "a14",
        "name": "Орхидея",
        "hex": "#b446ba",
        "foreground": "#ffffff",
        "contrast": 4.64
      },
      {
        "key": "a15",
        "name": "Пурпурный",
        "hex": "#8a3b75",
        "foreground": "#ffffff",
        "contrast": 7.09
      },
      {
        "key": "a16",
        "name": "Розовый",
        "hex": "#d1919f",
        "foreground": "#000000",
        "contrast": 8.26
      }
    ]
  }
}
